<svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L5.83696 5.93379C5.85736 5.95461 5.88242 5.97127 5.91049 5.98268C5.93856 5.9941 5.96899 6 5.99978 6C6.03057 6 6.06101 5.9941 6.08908 5.98268C6.11715 5.97127 6.14221 5.95461 6.16261 5.93379L11 1" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
